<template>
<div class="register">
  <body
    class="account-page"
    style="font-family: 'CircularStd', sans-serif;
    font-size: .9375rem;
    color: #1f1f1f;
    background-color: #f7f7f7;
    min-height: 100%;
    overflow-x: hidden;"
  >
    <!-- Main Wrapper -->
    <div class="main-wrapper">
      <div class="account-content">
        <div class="container">
          <!-- Account Logo -->
          <div class="account-logo">
            <router-link to="/index">
              <img v-bind:src="logoText" :alt="appTitle" />
            </router-link>
          </div>
          <!-- /Account Logo -->

          <div class="account-box">
            <div class="account-wrapper">
              <h3 class="account-title">Otp Confirmation</h3>
              <!-- <p class="account-subtitle">Free &amp; No credit card required.</p> -->
              <div class="alert alert-danger" v-if="isError">{{msgError}}</div>
              <div class="alert alert-success" v-if="isSuccess">{{msgSuccess}}</div>
              <!-- /Account Form -->
              <center>
                <button
                  :disabled="isDisabled"
                  @click="$router.push('/')"
                  class="btn btn-md"
                  type="submit"
                >&laquo; Back to Home</button>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Main Wrapper -->
  </body>
</div>
</template>

<script>
export default {
  data() {
    return {
      isSuccess: false,
      isError: false,
      msgSuccess: "",
      msgError: "",
      appTitle: process.env.VUE_APP_TITLE,
      logoText: process.env.VUE_APP_LOGO_TEXT,
      isDisabled: 0,
      //   isProcessing: "",
      fields: {
        id: "",
        code: ""
      }
    };
  },
  async created() {
    var id = await this.$route.query.id;
    var code = await this.$route.query.code;
    if (
      id != "" &&
      typeof id != "undefined" &&
      code != "" &&
      typeof code != "undefined"
    ) {
      this.fields.id = id;
      this.fields.code = code;
      this.confirmOtp();
    } else {
      // console.log("not found!");
      this.$router.push("/");
    }
  },
  methods: {
    async confirmOtp() {
      this.isDisabled = await 1;
      this.isSuccess = false;
      this.msgSuccess = "";
      this.isError = false;
      this.msgError = "";
      await this.$store
        .dispatch("otp/confirm", this.fields) // sesuai kan dengan method di API
        .then(response => {
          console.log("response", response);
          var { data } = response;
          this.isSuccess = true;
          this.msgSuccess = response["msg"];
          if (response["status"] == 200) {
            this.$fire({
              title: "Success",
              text: response["msg"],
              type: "success",
              timer: 3000
            }).then(r => {
              this.isDisabled = 0;
              if (data.ref == "registration") {
                this.$router.push("/login");
              } else {
                this.$router.push("/");
              }
            });
          }
        })
        .catch(error => {
          this.isDisabled = 0;
          this.$router.push("/");
        });
    }
  },
  name: "otpConfirm"
};
</script>


// WEBPACK FOOTER //
// src/views/register/confirm.vue